module.exports = __webpack_public_path__ + "static/media/choose-hp.fdfb0207.png";